import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TradeItemDto } from '@app/user/marks/marks-store/marks-types';

@Component({
    selector: 'app-search-product-list',
    templateUrl: './search-product-list.component.html',
    styleUrls: ['./search-product-list.component.scss']
})
export class SearchProductListComponent {
    @Input() public data: TradeItemDto[] = [];
    @Input() public notFound = false;
    @Output() public appSelect: EventEmitter<TradeItemDto> = new EventEmitter<TradeItemDto>();
    
    public onRowSelect(event: any): void {
        this.appSelect.emit(event.data as TradeItemDto);
    }
}
